export default "__VITE_ASSET__CoiEntfm__"